<template>
    <div class="m-checkbox-list" :class="inputClass">
        <label class="m-checkbox" v-for="(value, key) in checkboxes" v-bind:key="key">
            <input type="checkbox" :value="key" :name="'name['+key+']'">
            {{value}}
            <span></span>
        </label>
    </div>
</template>

<script>
export default {
  name: 'CheckboxComponent',
  props: ['id', 'value', 'name', 'placeholder', 'type', 'inputClass', 'checkboxes']
}
</script>



// WEBPACK FOOTER //
// src/components/core/form/inputs/CheckboxComponent.vue